import React from 'react';
import LoginForm from '../components/forms/LoginForm';
import { useAuth } from '../ReactApp';
import headerBackground from '../images/concrete-background-soluspots.png';
import LogoHeader from '../images/logos/LOGO_SOLUSPOTS_HEADER.png';
import { Link, useNavigate } from 'react-router-dom';

function LoginPage() {
    const { logIn } = useAuth();
    const navigate = useNavigate();

    return (
        <>
            <div className='login-top' style={{backgroundImage: `url(` + headerBackground + `)`}}>
                <div className="login-top-image">
                    <Link to="/"><img src={LogoHeader} alt="" /></Link>
                </div>
            </div>
            <LoginForm navigate={navigate} logIn={logIn}/>
        </>
    );
}

export default LoginPage;
